import PaymentSummary from "./PaymentSummary.view";

export default PaymentSummary;
